import apiCall from "./apiCall";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async fetchAdminList(data) 
  {
    let response = await apiCall("admin/list", data);
    return response;
  },

  async createAdmin(data) 
  {
    let response = await apiCall("admin/add", data);
    return response;
  },

  async fetchAdminNotifications(data) 
  {
    let response = await apiCall("mobile/webapp/admin_notifs", data);
    return response;
  },

  async fetchSchoolAdminListByPage(page) 
  {
    let data = {
      page: page
    };
    let response = await apiCall("school_user/list/page", data);
    return response;
  },

  async searchAllSchoolAdmins(search, page, school) {
    let data = {
      search: search,
      page: page,
      school_id: school
    };
    let response = await apiCall("school_user/list/page", data);
    return response;
  },
  async fetchPrintNotifList(page) 
  {
    let data = {
      page: page
    };
    let response = await apiCall("mobile/webapp/fingerprint_notifs", data);
    return response;
  },
  async searchPrintNotifList(page, search) 
  {
    let data = {
      page: page,
      search: search
    };
    let response = await apiCall("mobile/webapp/fingerprint_notifs", data);
    return response;
  },
};
